import { render, staticRenderFns } from "./UpdateTpcdModal.vue?vue&type=template&id=e198d014&"
import script from "./UpdateTpcdModal.vue?vue&type=script&lang=js&"
export * from "./UpdateTpcdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports